<div class="custom-choose-btn">
    <div class="btn btn-primary-2">
        <i class="feather icon-download"></i>
        <span class="ms-3">Import</span>
        <input type="file" (change)="onFileChange($event)" />
    </div>
</div>